import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Typography } from '@mui/material';
import useStyles from './styles';
const KEY_PREFIX = 'subscriptions.scheduleChange';
export const REASON_MAX_LENGTH = 500;
export const ScheduleChangeReasonField = _ref => {
  let value = _ref.value,
    onChange = _ref.onChange;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    label: t("".concat(KEY_PREFIX, ".reason_label")),
    placeholder: t("".concat(KEY_PREFIX, ".reason_placeholder")),
    value: value,
    onChange: onChange,
    inputProps: {
      maxLength: REASON_MAX_LENGTH
    },
    InputLabelProps: {
      shrink: true
    },
    multiline: true,
    minRows: 3,
    fullWidth: true
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.reasonCounter
  }, t("".concat(KEY_PREFIX, ".reason_counter"), {
    used: value.length,
    max: REASON_MAX_LENGTH
  })));
};